/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";

import BaseDynamicContainer from "./BaseDynamicContainer";
import {PageActionStore} from "../services/PageAction";

class BaseActionWizardStep extends BaseDynamicContainer {
    static propTypes = {
        onParamChange: PropTypes.func.isRequired,
        params: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool,
            componentProps: PropTypes.object
        }).isRequired,
        prevParams: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool,
            componentProps: PropTypes.object
        }),
    };

    static defaultProps = {};

    constructor(props, childStores) {
        super(props, _.extend({}, {
            action: PageActionStore
        }, childStores));
    }

    render() {
        return (
            <div/>
        );
    }

    onClickForward() {
        this.navigateForward();
    }

    onClickBack() {
        this.navigateBack();
    }

    navigateForward() {
        if (this.props.onParamChange) this.props.onParamChange("goto", "forward");
    }

    navigateBack() {
        if (this.props.onParamChange) this.props.onParamChange("goto", "back");
    }

    changeParam(paramName, paramValue) {
        if (this.props.onParamChange) this.props.onParamChange(paramName, paramValue);
    }

    /**
     * Execute action
     * @param {PageAction} action
     */
    onAction(action) {
        switch (action.action) {
            case "submit":
                this.onClickForward();
                break;
            case "back":
                this.onClickBack();
                break;
        }
    }

    storeChanged(key, newState, oldState) {
        switch (key) {
            case "action":
                this.onAction(newState.action);
                break;
            default:
                return super.storeChanged(key, newState, oldState);
        }
    }

}

export default BaseActionWizardStep;
